import * as React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import SuperAdminAssessmentsEditorPage from 'pages/super_admin/SuperAdminAssessmentsEditor';
import FacilityUserSettingsPage from 'pages/shared/FacilityUserSettings';
import PatientAccountsPage from 'pages/shared/PatientAccounts';
import PatientDetailsPage from 'pages/shared/PatientDetails';
import PatientRegistrationPage from 'pages/shared/PatientRegistration';
import PatientAccountSetupPage from 'pages/shared/PatientAccountSetup';
import FacilityUserAccountsPage from 'pages/shared/FacilityUserAccounts';
import FacilityUserRegistrationPage from 'pages/shared/FacilityUserRegistration';
import FacilityUserEditPage from 'pages/shared/FacilityUserEdit';
import ReportsPage from 'pages/admin/AdminReports';
import HelpPage from 'pages/shared/Help';
import Page404 from 'pages/errors/404';
import PatientResourcesPage from 'pages/patient/PatientResources';
import AssessmentPage from 'pages/shared/Survey';
import CoreMeasuresWorklistPage from 'pages/shared/CoreMeasuresWorklist';
import CoreMeasuresFacilityInfoPage from 'pages/shared/CoreMeasuresFacilityInfo';
import CoreMeasuresFacilityInfoPopulationEntryPage from 'pages/shared/CoreMeasuresFacilityInfoPopulationEntry';
import PixDataEntryPage from 'pages/shared/PixDataEntry';

import { SuperAdminRoutes, AllRoutes } from 'constants/routes';
import AssessmentResultsPage from 'pages/shared/AssessmentResult/assessmentResults';
import { PDFFileDownload } from 'pages/shared/PrintableAssessments/download';
import { HelpFileDownload } from 'pages/shared/Help/download';
import SuperAdminDashboardPage from '../SuperAdminDashboard';
import { AttachmentDownload } from '../../shared/Attachments/download';
import FacilityLibraryPage from '../../shared/FacilityLibrary';
import PatientEditPage from '../../shared/PatientEdit';

const SuperAdminRouting = (): React.JSX.Element => (
  <Router>
    <Switch>
      <Redirect exact path={AllRoutes.LOGIN} to={SuperAdminRoutes.DASHBOARD} />
      <Route exact path={SuperAdminRoutes.DASHBOARD} component={SuperAdminDashboardPage} />
      <Route path={`${SuperAdminRoutes.ASSESSMENT_EDITOR}/:assessmentDefinitionID`} component={SuperAdminAssessmentsEditorPage} />
      <Route path={`${SuperAdminRoutes.ASSESSMENT_EDITOR}`} component={SuperAdminAssessmentsEditorPage} />
      <Route exact path={SuperAdminRoutes.FACILITY_USER_ACCOUNTS} component={FacilityUserAccountsPage} />
      <Route path={SuperAdminRoutes.FACILITY_USER_REGISTRATION} component={FacilityUserRegistrationPage} />
      <Route path={`${SuperAdminRoutes.FACILITY_USER_EDIT}/:accountID`} component={FacilityUserEditPage} />
      <Route exact path={SuperAdminRoutes.PATIENT_ACCOUNTS} component={PatientAccountsPage} />
      <Route exact path={`${SuperAdminRoutes.PATIENT_REGISTRATION}/:facilityID`} component={PatientRegistrationPage} />
      <Route exact path={`${SuperAdminRoutes.PATIENT_ACCOUNTS}/:patient`} component={PatientDetailsPage} />
      <Route exact path={`${SuperAdminRoutes.PATIENT_ACCOUNTS}/:patient/account-setup`} component={PatientAccountSetupPage} />
      <Route exact path={`${SuperAdminRoutes.PATIENT_ACCOUNTS}/:patientId/edit`} component={PatientEditPage} />
      <Route path={SuperAdminRoutes.ADMIN_REPORTS} component={ReportsPage} />
      <Redirect exact path={AllRoutes.REPORTS} to={AllRoutes.ADMIN_REPORTS} />
      <Route path={SuperAdminRoutes.ACCOUNT} component={FacilityUserSettingsPage} />
      <Route path={AllRoutes.HELP_DOWNLOAD} component={HelpFileDownload} />
      <Route path={`${AllRoutes.ATTACHMENT_DOWNLOAD}/:attachmentId`} component={AttachmentDownload} />
      <Route path={SuperAdminRoutes.HELP} component={HelpPage} />
      <Route path={SuperAdminRoutes.RESOURCES} component={PatientResourcesPage} />
      <Route path={`${AllRoutes.DOWNLOAD}/:filename`} component={PDFFileDownload} />
      <Route path={`${SuperAdminRoutes.ASSESSMENT}/:assessmentNumber/:instrumentTypeID/:appliedWhenID/:patientID`} component={AssessmentPage} />
      <Route path={`${SuperAdminRoutes.ASSESSMENT_RESULTS}/:careID/:instrumentTypeID/:patientID`} component={AssessmentResultsPage} />
      <Route path={SuperAdminRoutes.CORE_MEASURES_WORKLIST} component={CoreMeasuresWorklistPage} />
      <Route path={SuperAdminRoutes.CORE_MEASURES_FACILITY_INFO} component={CoreMeasuresFacilityInfoPage} />
      <Route path={`${SuperAdminRoutes.CORE_MEASURES_FACILITY_INFO_POPULATION_ENTRY}`} component={CoreMeasuresFacilityInfoPopulationEntryPage} />
      <Route path={`${SuperAdminRoutes.FACILITY_LIBRARY}`} component={FacilityLibraryPage} />
      <Route path={`${AllRoutes.PIX_DATA_ENTRY}`} component={PixDataEntryPage} />
      <Route component={Page404} />
    </Switch>
  </Router>
);

export default SuperAdminRouting;
